<template>
  <components :is="tabsContent[active].name"></components>
</template>

<script>
import cpjs from "@/components/ip/cpjs.vue"
import tcgm from "@/components/ip/tcgm.vue"
import cjwt from "@/components/ip/cjwt.vue"
export default {
  props: {
    active: {
      tyepe: [Number, String],
      default: 0,
    },
  },
  components: {
    cpjs,
    tcgm,
    cjwt,
  },
  data () {
    return {
      tabsContent: [
        { id: 0, name: "cpjs" },
        { id: 1, name: "tcgm" },
        { id: 2, name: "cjwt" },
      ],
    }
  },
};
</script>
